import { HttpErrorResponse } from '@angular/common/http';

export type NatureErreurApi = 'metier' | 'http' | 'reseau' | 'reponse_invalide';

/** Erreur exploitable par les écrans sans connaître la forme de la réponse HTTP. */
export class ErreurApi extends Error {
  override readonly name = 'ErreurApi';

  constructor(
    message: string,
    readonly nature: NatureErreurApi,
    readonly details?: string | string[],
    readonly status?: number,
    override readonly cause?: unknown,
  ) {
    super(message);
  }
}

function lireCorpsErreur(valeur: unknown): { message?: string; details?: string | string[] } {
  if (!valeur || typeof valeur !== 'object') return {};
  const corps = valeur as Record<string, unknown>;
  const message = typeof corps['message'] === 'string' ? corps['message'].trim() : undefined;
  const details = corps['details'];
  return {
    message: message || undefined,
    details:
      typeof details === 'string' ||
      (Array.isArray(details) && details.every((detail) => typeof detail === 'string'))
        ? details
        : undefined,
  };
}

/** Ne transforme pas les erreurs de programmation ni les annulations en erreurs API. */
export function normaliserErreurHttp(erreur: unknown): unknown {
  if (!(erreur instanceof HttpErrorResponse)) return erreur;
  const corps = lireCorpsErreur(erreur.error);
  return new ErreurApi(
    corps.message ??
      (erreur.status === 0
        ? 'Impossible de joindre le serveur. Vérifiez votre connexion puis réessayez.'
        : 'La requête a échoué. Veuillez réessayer.'),
    erreur.status === 0 ? 'reseau' : 'http',
    corps.details,
    erreur.status,
    erreur,
  );
}

/** Récupère uniquement le message et les détails métier, sans le message technique HTTP de secours. */
export function explicationErreurApi(erreur: ErreurApi): {
  message?: string;
  details?: string | string[];
} {
  return erreur.cause instanceof HttpErrorResponse
    ? lireCorpsErreur(erreur.cause.error)
    : { message: erreur.message.trim() || undefined, details: erreur.details };
}

export function messageErreurApi(
  erreur: unknown,
  repli = 'Impossible de charger les données.',
): string {
  const normalisee = normaliserErreurHttp(erreur);
  return normalisee instanceof ErreurApi ? normalisee.message : repli;
}
